import { FC, ReactNode } from 'react';
import { cn, FaIcon } from '@fe-learner-common';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export type TagType =
  | 'ghost'
  | 'neutral'
  | 'positive'
  | 'negative'
  | 'attention'
  | 'prominence';
interface TagProps {
  className?: string;
  children: ReactNode;
  icon?: IconDefinition;
  type?: TagType;
}

const typeMap = {
  ghost: 'lf:bg-neutral-0 lf:text-neutral-500',
  neutral: 'lf:bg-neutral-100 lf:text-neutral-550',
  positive: 'lf:bg-positive-50 lf:text-positive-500',
  negative: 'lf:bg-negative-50 lf:text-negative-500',
  attention: 'lf:bg-attention-50 lf:text-attention-500',
  prominence: 'lf:bg-prominence-50 lf:text-prominence-500',
};

export const Tag: FC<TagProps> = ({
  className,
  children,
  icon,
  type,
  ...rest
}) => {
  const typeClass = (type && typeMap[type]) || typeMap.neutral;
  return (
    <span
      className={cn(
        'lf:inline-flex lf:h-fit lf:items-center lf:gap-1 lf:rounded-full lf:bg-neutral-100 lf:px-1.5 lf:py-0.5 lf:text-label-sm lf:tracking-[.5px] lf:text-neutral-550',
        typeClass,
        className,
      )}
      {...rest}
    >
      {icon && <FaIcon width={12} height={12} icon={icon} />}
      {children}
    </span>
  );
};
